import { useLocation } from 'react-router';
import { Routes } from '../../../../Routes.constants';

export const useParentPath = () => {
  const location = useLocation();
  const numberOfPathParts = location.pathname.includes(Routes.products) ? 3 : 2;
  const currentPath = location.pathname.split('/').slice(0, numberOfPathParts);
  return currentPath.join('/');
};
